var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11L7.66667 7.66667L11 11ZM8.77778 4.88889C8.77778 5.39959 8.67719 5.90528 8.48175 6.3771C8.28632 6.84892 7.99987 7.27763 7.63875 7.63875C7.27763 7.99987 6.84892 8.28632 6.3771 8.48175C5.90528 8.67719 5.39959 8.77778 4.88889 8.77778C4.37819 8.77778 3.8725 8.67719 3.40068 8.48175C2.92885 8.28632 2.50015 7.99987 2.13903 7.63875C1.77791 7.27763 1.49146 6.84892 1.29602 6.3771C1.10059 5.90528 1 5.39959 1 4.88889C1 3.85749 1.40972 2.86834 2.13903 2.13903C2.86834 1.40972 3.85749 1 4.88889 1C5.92029 1 6.90944 1.40972 7.63875 2.13903C8.36806 2.86834 8.77778 3.85749 8.77778 4.88889Z",
    stroke: "#6B7D8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.50b4d8c94e4c5537b4eae498e665f421.svg";
export { ForwardRef as ReactComponent };